import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_SalesArea_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB SalesArea Id', columnResourceName: 'colwbId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB SalesOrg Id',
            columnResourceName: 'colwbSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Area ID', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    SALESAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Area Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    ENTERPRISE_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Key Set', columnResourceName: 'colKeySet', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    BUSINESS_AREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Business Area',
            columnResourceName: 'colBusinessArea',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB MDSet Id', columnResourceName: 'colwbId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },

};

const SalesAreaSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_SALESAREA_ID',
        id_ui: 'SALESAREA_ID',
        name: 'SALESAREA_NAME'
    },

    searchProviderFields: vUI_SalesArea_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
                let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    searchRequestSubset.where['WB_SALESAREA_ID'] = {inq: _.map(usrContext.WB_SalesAreas, 'WB_SALESAREA_ID')}
                }
                let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                    'vUI_SalesArea_Search',
                    this.searchProviderFields,
                    []);

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err) => {
                        error(err)
                    });
            }
        )
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset = {
                    where: {'WB_SALESAREA_ID': {inq: _.map(usrContext.WB_SalesAreas, 'WB_SALESAREA_ID')}}
                }
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_SalesArea_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const SalesAreaSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SalesAreaSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Sales Area ID', searchProviderFieldId: 'SALESAREA_ID', renderOptions: {}},
        {profileFilterName: 'Sales Area Name', searchProviderFieldId: 'SALESAREA_NAME', renderOptions: {}}
    ],
    profileDisplayFields: [
        'SALESAREA_ID', 'SALESAREA_NAME', 'ENTERPRISE_SET_ID', 'BUSINESS_AREA_ID'
    ],

    profileSearchProvider: SalesAreaSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SalesAreaSearch: ISearch = {
    searchName: "Find SalesArea",
    renderOptions: {ui5ResourceId: "SalesAreaSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SalesAreaSearchProfileByName]
};

export {SalesAreaSearch}